<mat-form-field class="text-array-filter" [formGroup]="paramsGroup">
  <mat-label>Values</mat-label>
  <input
    [matChipInputFor]="chipGrid"
    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
    (matChipInputTokenEnd)="add($event)"
    placeholder="Value" />
  <mat-chip-grid #chipGrid formControlName="value">
    @for (value of values; track value) {
      <mat-chip-row (removed)="remove(value)">
        {{ value }}
        <button matChipRemove><span class="material-symbols-outlined">cancel</span></button>
      </mat-chip-row>
    }
  </mat-chip-grid>
  @if (paramsGroup.get('value')?.hasError('required')) {
    <mat-error>This field is required</mat-error>
  }
</mat-form-field>
